import { render, staticRenderFns } from "./taskInformation.vue?vue&type=template&id=29886883&scoped=true&"
import script from "./taskInformation.vue?vue&type=script&lang=js&"
export * from "./taskInformation.vue?vue&type=script&lang=js&"
import style0 from "./taskInformation.vue?vue&type=style&index=0&id=29886883&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29886883",
  null
  
)

export default component.exports